import { withAuthRequired } from '@/lib/middleware';
import { Layout } from '@/features/anken/components/Layout';
import { AnkenSkeletonContainer } from '@/features/anken/components/Skeleton';
import { SkeletonRect } from '@/components/skeleton/SkeletonRect';
import { Home } from '@/features/home/components/Home';

const Skeleton = () => (
  <AnkenSkeletonContainer>
    <div className="flex flex-col gap-6 p-6">
      <SkeletonRect className="h-8 w-40" />
      <SkeletonRect className="h-16 w-full" />
      <SkeletonRect className="h-16 w-full" />
    </div>
  </AnkenSkeletonContainer>
);

const HomePage = () => (
  <Layout skeleton={<Skeleton />}>
    <Home />
  </Layout>
);

export default withAuthRequired(HomePage, () => <Skeleton />);
